export default __webpack_public_path__ + "static/media/headshot.815fea52.png";